/**
 * Cupón Chile Salud — modal al estilo Receta Solidaria.
 * Un cupón por pedido (el de la entidad), aplicado a los productos del programa.
 */
(function () {
  function farmexSwalFire(options) {
    if (typeof Swal === 'undefined') return Promise.resolve();
    return Swal.fire(
      Object.assign(
        {
          target: document.body,
          heightAuto: false
        },
        options || {}
      )
    );
  }

  window.productosChileSalud = window.productosChileSalud || [];
  window.cuponChileSalud = window.cuponChileSalud || '';
  window.cuponesChileSaludMap = window.cuponesChileSaludMap || {};
  window.cuponChileSaludEstado = window.cuponChileSaludEstado || { estado: 'pendiente', mensaje: '' };

  const CS_USAR_API_LOCAL = false;
  const FARMEX_API_BASE = 'https://services.farmex.cl';
  const NGROK_API_BASE = 'https://e866-190-215-90-239.ngrok-free.app';

  function getCsApiBase() {
    if (typeof window.FARMEX_API_BASE_URL === 'string' && window.FARMEX_API_BASE_URL.trim()) {
      return window.FARMEX_API_BASE_URL.trim().replace(/\/$/, '');
    }
    return (CS_USAR_API_LOCAL ? NGROK_API_BASE : FARMEX_API_BASE).replace(/\/$/, '');
  }

  function getCsApiHeaders() {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    };
    if (getCsApiBase().indexOf('ngrok') !== -1) {
      headers['ngrok-skip-browser-warning'] = 'true';
    }
    return headers;
  }

  function escapeHtmlCs(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getProductosChileSaludModal() {
    return window.productosChileSalud || [];
  }

  function getCuponChileSaludEnvio() {
    if (window.cuponChileSaludEstado?.estado !== 'valid') return null;
    const productos = getProductosChileSaludModal();
    const map = window.cuponesChileSaludMap || {};
    if (productos.length > 0 && productos.every((p) => map[p.sku])) {
      return String(map[productos[0].sku] || '').trim() || null;
    }
    const valor = String(window.cuponChileSalud || '').trim();
    return valor !== '' ? valor : null;
  }

  function cuponChileSaludValido() {
    return window.cuponChileSaludEstado?.estado === 'valid' && !!getCuponChileSaludEnvio();
  }

  function estaBeneficioChileSaludSeleccionado() {
    const csCheckbox =
      document.getElementById('ChileSalud') ||
      document.querySelector('.radioModalBeneficios[value="ChileSalud"]');
    return !!(csCheckbox && csCheckbox.checked);
  }

  function syncHiddenCuponChileSalud() {
    const hidden = document.getElementById('cInputChileSalud');
    if (hidden) hidden.value = getCuponChileSaludEnvio() || '';
    const input = document.getElementById('csCuponGlobalInput');
    if (input && window.cuponChileSalud && input.value.trim() === '') {
      input.value = window.cuponChileSalud;
    }
  }

  function getResumenCuponesCs() {
    const productos = getProductosChileSaludModal();
    const estado = window.cuponChileSaludEstado?.estado || 'pendiente';
    const validos = estado === 'valid' ? productos.length : 0;
    const invalidos = estado === 'invalid' ? 1 : 0;
    const pendientes = estado === 'pendiente' || estado === '' ? 1 : 0;

    return {
      total: productos.length,
      activos: productos.length,
      validos,
      invalidos,
      pendientes,
      completos: productos.length > 0 && estado === 'valid'
    };
  }

  function actualizarPasosCuponesCs(resumen) {
    const steps = document.querySelectorAll('#modalCuponesChileSalud .rs-cupones-step');
    if (!steps.length) return;

    const r = resumen || getResumenCuponesCs();
    let pasoActivo = 1;
    if (r.validos > 0 || r.invalidos > 0) pasoActivo = 2;
    if (r.completos) pasoActivo = 3;

    steps.forEach((step) => {
      const n = parseInt(step.getAttribute('data-cs-step'), 10);
      step.classList.remove('rs-cupones-step--active', 'rs-cupones-step--done');
      if (n < pasoActivo) step.classList.add('rs-cupones-step--done');
      else if (n === pasoActivo) step.classList.add('rs-cupones-step--active');
    });
  }

  function actualizarProgresoCuponesCs() {
    const resumen = getResumenCuponesCs();
    const wrap = document.getElementById('csCuponesProgressWrap');
    const label = document.getElementById('csCuponesProgressLabel');
    const count = document.getElementById('csCuponesProgressCount');
    const bar = document.getElementById('csCuponesProgressBar');
    const fill = document.getElementById('csCuponesProgressFill');
    const hint = document.getElementById('csCuponesFooterHint');
    const btnGuardar = document.getElementById('btnGuardarCuponesCS');
    const input = document.getElementById('csCuponGlobalInput');

    if (wrap) wrap.hidden = resumen.activos === 0;

    const pct = resumen.completos ? 100 : resumen.invalidos > 0 ? 40 : 0;

    if (count) {
      count.textContent = resumen.completos
        ? resumen.activos + ' de ' + resumen.activos + ' productos'
        : '0 de ' + resumen.activos + ' validados';
    }
    if (label) {
      if (resumen.completos) label.textContent = '¡Listo para aplicar convenio!';
      else if (resumen.invalidos > 0) label.textContent = 'Revisa el cupón';
      else label.textContent = 'Progreso de validación';
    }
    if (fill) {
      fill.style.width = pct + '%';
      fill.classList.toggle('rs-progress-complete', resumen.completos);
    }
    if (bar) bar.setAttribute('aria-valuenow', String(pct));

    if (input) {
      input.classList.toggle('rs-cupon-valid', resumen.completos);
      input.classList.toggle('rs-cupon-invalid', resumen.invalidos > 0);
    }

    if (hint) {
      hint.classList.remove('rs-hint-success', 'rs-hint-warning');
      if (resumen.completos) {
        hint.textContent = 'Cupón validado. Al confirmar se aplicará el convenio automáticamente.';
        hint.classList.add('rs-hint-success');
      } else if (resumen.invalidos > 0) {
        hint.textContent = window.cuponChileSaludEstado?.mensaje || 'El cupón no es válido.';
        hint.classList.add('rs-hint-warning');
      } else {
        hint.textContent = 'Ingresa tu cupón Chile Salud y presiona «Validar cupón».';
      }
    }

    if (btnGuardar) {
      btnGuardar.classList.toggle('rs-btn-ready', resumen.completos);
      if (!btnGuardar.disabled) {
        btnGuardar.textContent = resumen.completos
          ? 'Validar y aplicar convenio'
          : btnGuardar.dataset.csLabelOriginal || 'Validar cupón';
      }
    }

    actualizarPasosCuponesCs(resumen);
    actualizarEstadoCuponesCsEnCarrito(resumen);
    return resumen;
  }

  function actualizarEstadoCuponesCsEnCarrito(resumen) {
    const r = resumen || getResumenCuponesCs();
    const badge = document.getElementById('csBtnCuponesBadge');
    const hint = document.getElementById('csBeneficioHint');
    const btn = document.getElementById('btnVerCuponesCS');

    if (badge) {
      if (r.activos === 0) {
        badge.hidden = true;
      } else if (r.completos) {
        badge.hidden = false;
        badge.textContent = 'Listo';
        badge.className = 'rs-btn-rs-badge rs-badge-complete';
      } else {
        badge.hidden = false;
        badge.textContent = r.activos + ' prod.';
        badge.className = 'rs-btn-rs-badge';
      }
    }

    if (hint) {
      hint.classList.remove('rs-hint-ok', 'rs-hint-pending');
      if (r.completos) {
        hint.textContent = 'Cupón validado. Usa «Validar cupón» para aplicar el descuento.';
        hint.classList.add('rs-hint-ok');
      } else if (r.activos > 0) {
        hint.textContent = '0 de ' + r.activos + ' cupones validados.';
        hint.classList.add('rs-hint-pending');
      } else {
        hint.textContent = '';
      }
    }

    if (btn) btn.classList.toggle('rs-btn-complete', !!r.completos);
  }

  function renderProductosChileSalud() {
    const contenedor = document.getElementById('csCuponesTablaContenedor');
    if (!contenedor) return;

    const productos = getProductosChileSaludModal();
    if (productos.length === 0) {
      contenedor.innerHTML =
        '<p class="rs-cupones-empty">No hay productos de Chile Salud en tu carrito.</p>';
      actualizarProgresoCuponesCs();
      return;
    }

    const estado = window.cuponChileSaludEstado?.estado || 'pendiente';
    let cards = '';
    productos.forEach((p) => {
      const titulo = escapeHtmlCs(p.title);
      let estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-pendiente">Pendiente</span>';
      let cardMod = '';
      if (estado === 'valid') {
        estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-valid">✓ Incluido</span>';
        cardMod = ' rs-cupon-card--valid';
      } else if (estado === 'invalid') {
        estadoHtml = '<span class="rs-cupon-estado rs-cupon-estado-invalid">✗ Cupón inválido</span>';
        cardMod = ' rs-cupon-card--invalid';
      }

      const map = window.cuponesChileSaludMap || {};
      const codigoProducto = map[p.sku] ? '<p class="rs-cupon-card__shared">Cupón: ' + escapeHtmlCs(map[p.sku]) + '</p>' : '';
      cards +=
        '<article class="rs-cupon-card' +
        cardMod +
        '">' +
        '<div class="rs-cupon-card__header">' +
        '<h6 class="rs-cupon-card__title">' +
        titulo +
        '</h6>' +
        estadoHtml +
        '</div>' +
        codigoProducto +
        '</article>';
    });

    if (productos.length > 5) {
      cards =
        '<p class="rs-cupones-empty" style="color:#b91c1c;border-color:#fca5a5;">No puedes aplicar Chile Salud a más de 5 productos. Ajusta tu carrito.</p>' +
        cards;
    }

    contenedor.innerHTML = '<div class="rs-cupones-list">' + cards + '</div>';
    actualizarProgresoCuponesCs();
  }

  function setCsCuponesLoading(activo, textoBoton) {
    const overlay = document.getElementById('csCuponesLoadingOverlay');
    const overlayText = overlay ? overlay.querySelector('.rs-cupones-loading-text') : null;
    const modalEl = document.getElementById('modalCuponesChileSalud');
    const btnGuardar = document.getElementById('btnGuardarCuponesCS');
    const btnCancelar = document.getElementById('btnCancelarCuponesCS');
    const btnAuto = document.getElementById('btnSolicitarCuponAutomaticoCS');

    if (overlay) overlay.hidden = !activo;
    if (overlayText) {
      overlayText.textContent = textoBoton || 'Validando cupón, por favor espera…';
    }
    if (modalEl) modalEl.setAttribute('aria-busy', activo ? 'true' : 'false');

    if (btnGuardar) {
      if (activo) {
        if (!btnGuardar.dataset.csLabelOriginal) {
          btnGuardar.dataset.csLabelOriginal = btnGuardar.textContent.trim();
        }
        btnGuardar.disabled = true;
        btnGuardar.innerHTML = '<span class="rs-btn-spinner" aria-hidden="true"></span> ' + (textoBoton || 'Validando…');
      } else {
        btnGuardar.disabled = false;
        btnGuardar.textContent = btnGuardar.dataset.csLabelOriginal || 'Validar cupón';
      }
    }
    if (btnCancelar) btnCancelar.disabled = !!activo;
    if (btnAuto) btnAuto.disabled = !!activo;
  }

  async function validarCuponChileSaludAPI(cupon) {
    const cuponLimpio = String(cupon || '').trim();
    if (!cuponLimpio) {
      return { valido: false, mensaje: 'Ingresa tu cupón Chile Salud' };
    }
    if (!/^\d+$/.test(cuponLimpio)) {
      return { valido: false, mensaje: 'El cupón Chile Salud debe ser numérico' };
    }

    try {
      const url = getCsApiBase() + '/api/validar-cupon-chile-salud';
      const response = await axios.get(url, {
        params: { cupon: cuponLimpio },
        headers: getCsApiHeaders()
      });
      const payload = response.data || {};
      if (payload.valid === true) {
        return { valido: true, mensaje: payload.message || 'Cupón válido' };
      }
      return {
        valido: false,
        mensaje: payload.message || payload.error || 'Cupón no válido'
      };
    } catch (error) {
      const data = error.response?.data || {};
      return {
        valido: false,
        mensaje: data.error || data.message || 'No se pudo validar el cupón. Intenta nuevamente.'
      };
    }
  }

  async function guardarYValidarCuponChileSalud() {
    const input = document.getElementById('csCuponGlobalInput');
    const valor = (input?.value || '').trim();
    const productos = getProductosChileSaludModal();

    if (productos.length > 5) {
      window.cuponChileSaludEstado = {
        estado: 'invalid',
        mensaje: 'No puedes comprar más de 5 productos de Chile Salud.'
      };
      renderProductosChileSalud();
      return { validos: 0, invalidos: 1, vacios: 0, todosCompletos: false };
    }

    if (!valor) {
      window.cuponChileSalud = '';
      window.cuponesChileSaludMap = {};
      window.cuponChileSaludEstado = { estado: 'pendiente', mensaje: '' };
      syncHiddenCuponChileSalud();
      renderProductosChileSalud();
      return { validos: 0, invalidos: 0, vacios: 1, todosCompletos: false };
    }

    setCsCuponesLoading(true);
    try {
      const resultado = await validarCuponChileSaludAPI(valor);
      if (resultado.valido) {
        window.cuponChileSalud = valor;
        window.cuponesChileSaludMap = {};
        getProductosChileSaludModal().forEach((p) => {
          if (p.sku) window.cuponesChileSaludMap[p.sku] = valor;
        });
        window.cuponChileSaludEstado = { estado: 'valid', mensaje: resultado.mensaje };
        syncHiddenCuponChileSalud();
        renderProductosChileSalud();
        return { validos: 1, invalidos: 0, vacios: 0, todosCompletos: true };
      }

      window.cuponChileSalud = valor;
      window.cuponChileSaludEstado = { estado: 'invalid', mensaje: resultado.mensaje };
      syncHiddenCuponChileSalud();
      renderProductosChileSalud();
      return { validos: 0, invalidos: 1, vacios: 0, todosCompletos: false };
    } finally {
      setCsCuponesLoading(false);
    }
  }

  function emailValidoCs(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function shopifyLinePriceToClp(linePrice) {
    const n = Number(linePrice || 0);
    if (!Number.isFinite(n) || n <= 0) return 0;
    if (n >= 1000 && n % 100 === 0) return Math.round(n / 100);
    return Math.round(n);
  }

  function getRutChileSalud() {
    const desdeStorage = String(localStorage.getItem('RUT') || '').trim();
    if (desdeStorage) return desdeStorage;
    const inputRut = document.querySelector('#form_rut_discount input[name="rut"]');
    return String(inputRut && inputRut.value ? inputRut.value : '').trim();
  }

  async function armarProductosCuponAutomaticoCs() {
    const productosCs = getProductosChileSaludModal();
    let cart = { items: [], token: '' };
    try {
      const response = await fetch('/cart.js');
      cart = await response.json();
    } catch (e) {
      /* noop */
    }
    const bySku = {};
    (cart.items || []).forEach((item) => {
      const sku = String(item.sku || '').trim();
      if (sku) bySku[sku] = item;
    });
    return {
      cartToken: cart.token || '',
      productos: productosCs.map((p) => {
        const line = bySku[p.sku] || {};
        const qty = Number(p.qty || line.quantity || 1);
        const linePrice = Number(line.original_line_price || line.final_line_price || 0);
        return {
          sku: p.sku,
          cantidad: qty,
          montoVenta: shopifyLinePriceToClp(linePrice),
          ean13: p.sku
        };
      })
    };
  }

  async function solicitarCuponAutomaticoChileSalud() {
    const emailInput = document.getElementById('csCuponEmailInput');
    const email = String(emailInput && emailInput.value ? emailInput.value : '').trim();
    if (!emailValidoCs(email)) {
      if (emailInput) emailInput.classList.add('rs-cupon-invalid');
      await farmexSwalFire({
        title: 'Correo inválido',
        text: 'Ingresa un correo válido para solicitar el cupón automático.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }
    if (emailInput) emailInput.classList.remove('rs-cupon-invalid');
    try {
      localStorage.setItem('chileSaludEmail', email);
    } catch (e) {
      /* noop */
    }

    const rut = getRutChileSalud();
    if (!rut) {
      await farmexSwalFire({
        title: 'Falta el RUT',
        text: 'Ingresa tu RUT en el carrito antes de solicitar el cupón.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }

    const productos = getProductosChileSaludModal();
    if (!productos.length) {
      await farmexSwalFire({
        title: 'Sin productos',
        text: 'No hay productos Chile Salud en tu carrito.',
        icon: 'info',
        confirmButtonText: 'Entendido'
      });
      return;
    }
    if (productos.length > 5) {
      await farmexSwalFire({
        title: 'Límite de productos',
        text: 'No puedes solicitar cupón para más de 5 productos Chile Salud.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
      return;
    }

    const payloadBase = await armarProductosCuponAutomaticoCs();
    setCsCuponesLoading(true, 'Solicitando cupón…');
    try {
      const url = getCsApiBase() + '/api/chile-salud/crear-cupon-automatico';
      const response = await axios.post(
        url,
        {
          rut: rut,
          email: email,
          cart_token: payloadBase.cartToken,
          productos: payloadBase.productos
        },
        { headers: getCsApiHeaders() }
      );
      const payload = response.data || {};
      const data = payload.data || payload;
      const cupones = Array.isArray(data.cupones) ? data.cupones : [];
      const errores = Array.isArray(data.errores) ? data.errores : [];
      if (!cupones.length) {
        throw { response: { data: payload } };
      }

      const map = {};
      cupones.forEach((fila) => {
        if (fila && fila.sku && fila.codigo) map[fila.sku] = String(fila.codigo);
      });
      window.cuponesChileSaludMap = map;
      window.cuponChileSalud = String(cupones[0].codigo || '');
      const input = document.getElementById('csCuponGlobalInput');
      if (input) input.value = window.cuponChileSalud;

      const todos = productos.every((p) => map[p.sku]);
      window.cuponChileSaludEstado = {
        estado: todos ? 'valid' : 'invalid',
        mensaje: todos
          ? 'Cupón automático generado.'
          : (errores[0] && errores[0].mensaje) || 'No se pudo generar cupón para todos los productos.'
      };
      syncHiddenCuponChileSalud();
      renderProductosChileSalud();

      if (!todos) {
        await farmexSwalFire({
          title: 'Cupón parcial',
          text: window.cuponChileSaludEstado.mensaje,
          icon: 'warning',
          confirmButtonText: 'Entendido'
        });
        return;
      }

      const modalEl = document.getElementById('modalCuponesChileSalud');
      if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
        bootstrap.Modal.getOrCreateInstance(modalEl).hide();
      } else if (modalEl) {
        modalEl.style.display = 'none';
        modalEl.classList.remove('show');
      }
      await intentarAplicarConvenioTrasValidarCuponCs();
    } catch (error) {
      const data = (error && error.response && error.response.data) || {};
      const mensaje =
        data.message ||
        data.error ||
        (data.errors && data.errors.email && data.errors.email[0]) ||
        'No se pudo generar el cupón automático.';
      await farmexSwalFire({
        title: 'No se pudo generar el cupón',
        text: mensaje,
        icon: 'error',
        confirmButtonText: 'Entendido'
      });
    } finally {
      setCsCuponesLoading(false);
    }
  }

  async function intentarAplicarConvenioTrasValidarCuponCs() {
    if (!cuponChileSaludValido() || !estaBeneficioChileSaludSeleccionado()) {
      return false;
    }
    if (typeof btnAceptarBeneficio_Click === 'function') {
      await btnAceptarBeneficio_Click();
      return true;
    }
    const btnAplicar = document.getElementById('btnAceptarBeneficio');
    if (btnAplicar) {
      btnAplicar.click();
      return true;
    }
    return false;
  }

  window.abrirModalCuponesCS = function abrirModalCuponesCS() {
    const input = document.getElementById('csCuponGlobalInput');
    if (input && window.cuponChileSalud) input.value = window.cuponChileSalud;
    const emailInput = document.getElementById('csCuponEmailInput');
    if (emailInput && !emailInput.value) {
      try {
        emailInput.value = localStorage.getItem('chileSaludEmail') || '';
      } catch (e) {
        /* noop */
      }
    }
    renderProductosChileSalud();
    const btnGuardar = document.getElementById('btnGuardarCuponesCS');
    if (btnGuardar && !btnGuardar.dataset.csLabelOriginal) {
      btnGuardar.dataset.csLabelOriginal = 'Validar cupón';
    }
    const modalEl = document.getElementById('modalCuponesChileSalud');
    if (!modalEl) return;
    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
      bootstrap.Modal.getOrCreateInstance(modalEl, { backdrop: 'static', keyboard: false }).show();
    } else {
      modalEl.style.display = 'block';
      modalEl.classList.add('show');
    }
  };

  window.getCuponChileSaludEnvio = getCuponChileSaludEnvio;
  window.cuponChileSaludValido = cuponChileSaludValido;
  window.actualizarEstadoCuponesCsEnCarrito = actualizarEstadoCuponesCsEnCarrito;

  document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById('csCuponGlobalInput');
    if (input) {
      input.addEventListener('input', function () {
        window.cuponChileSaludEstado = { estado: 'pendiente', mensaje: '' };
        window.cuponChileSalud = (input.value || '').trim();
        window.cuponesChileSaludMap = {};
        const hidden = document.getElementById('cInputChileSalud');
        if (hidden) hidden.value = '';
        renderProductosChileSalud();
      });
      input.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        const btn = document.getElementById('btnGuardarCuponesCS');
        if (btn && !btn.disabled) btn.click();
      });
    }

    const btnGuardar = document.getElementById('btnGuardarCuponesCS');
    if (btnGuardar) {
      if (!btnGuardar.dataset.csLabelOriginal) {
        btnGuardar.dataset.csLabelOriginal = 'Validar cupón';
      }
      btnGuardar.addEventListener('click', async function () {
        const resultado = await guardarYValidarCuponChileSalud();
        if (resultado.todosCompletos) {
          const modalEl = document.getElementById('modalCuponesChileSalud');
          if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
            bootstrap.Modal.getOrCreateInstance(modalEl).hide();
          } else if (modalEl) {
            modalEl.style.display = 'none';
            modalEl.classList.remove('show');
          }
          await intentarAplicarConvenioTrasValidarCuponCs();
          return;
        }

        let icon = 'info';
        let title = 'Falta el cupón';
        let text = 'Ingresa tu cupón Chile Salud antes de validar.';
        if (resultado.invalidos > 0) {
          icon = 'warning';
          title = 'Cupón no válido';
          text = window.cuponChileSaludEstado?.mensaje || 'Revisa el código e intenta nuevamente.';
        }

        await farmexSwalFire({ title: title, text: text, icon: icon, confirmButtonText: 'Entendido' });
      });
    }

    const btnAuto = document.getElementById('btnSolicitarCuponAutomaticoCS');
    if (btnAuto) {
      btnAuto.addEventListener('click', function () {
        solicitarCuponAutomaticoChileSalud();
      });
    }

    const emailInput = document.getElementById('csCuponEmailInput');
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        emailInput.classList.remove('rs-cupon-invalid');
      });
      emailInput.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (btnAuto && !btnAuto.disabled) btnAuto.click();
      });
    }

    const jumpLink = document.getElementById('csCuponAutoJumpLink');
    if (jumpLink) {
      jumpLink.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.getElementById('csCuponAutoBlock');
        const modalBody = document.querySelector('#modalCuponesChileSalud .modal-body-rs-cupones');
        if (!target) return;

        if (modalBody) {
          const bodyRect = modalBody.getBoundingClientRect();
          const targetRect = target.getBoundingClientRect();
          const nextTop = modalBody.scrollTop + (targetRect.top - bodyRect.top) - 8;
          modalBody.scrollTo({ top: Math.max(0, nextTop), behavior: 'smooth' });
        } else {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        window.setTimeout(function () {
          const focusEl = document.getElementById('csCuponEmailInput');
          if (focusEl) focusEl.focus({ preventScroll: true });
          else target.focus({ preventScroll: true });
        }, 280);
      });
    }

    actualizarEstadoCuponesCsEnCarrito();
  });
})();
